import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import ContactSection from "../../Components/ContactSection/ContactSection";
import Footer from "../../Components/Common/Footer";

class ContactPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <ContactSection />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default ContactPage;
